<script setup lang="ts">
definePageMeta({
  middleware: 'home-layout',
})

const { isSignatureHost } = useHomeLayoutMode()
</script>

<template>
  <SignatureGenerator v-if="isSignatureHost" />
  <Page v-else />
</template>
